var path = '/pages/categories/views/categories-list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/categories/views/categories-list.tpl.html
// module id = 2212
// module chunks = 1